/**
 * Window events that open the free-credit windows from anywhere: the planning
 * More menu's "Free credits" item, and the invite prompt after someone closes
 * the upgrade window without buying, and the More menu's Upgrade / Add credits
 * items. FreeCreditsHost renders them.
 */
export const OPEN_REFER_EARN_EVENT = '8080:open-refer-earn';
export const UPGRADE_DISMISSED_EVENT = '8080:upgrade-dismissed';
export const OPEN_BILLING_EVENT = '8080:open-billing';

export type BillingView = 'plans' | 'credits';

export const openReferEarn = (): void => {
  window.dispatchEvent(new Event(OPEN_REFER_EARN_EVENT));
};

export const announceUpgradeDismissed = (): void => {
  window.dispatchEvent(new Event(UPGRADE_DISMISSED_EVENT));
};

export const openBilling = (view: BillingView): void => {
  window.dispatchEvent(new globalThis.CustomEvent<BillingView>(OPEN_BILLING_EVENT, { detail: view }));
};
